import { useEffect } from 'react';

import type { Provider, CollabEditProvider } from '@atlaskit/collab-provider';

import { COLLAB_EDIT_PROVIDER_MEASURES } from '@confluence/fabric-providers';
import { CollabEditProviderMeasures } from '@confluence/action-measures';

/**
 * Listens to passed in collab provider connecting event and marks connected start time.
 */
export const useConnecting = (collabEditProvider: (CollabEditProvider & Provider) | null) => {
	const handleConnecting = () => {
		// tracking time between when provider is created in the FE and when channel initialization starts
		CollabEditProviderMeasures.markMeasureEnd(
			COLLAB_EDIT_PROVIDER_MEASURES.COLLAB_EDIT_PROVIDER_PRE_CONNECTED,
		);
		// tracking time between when provider's channel is initialized and when connected event is fired
		CollabEditProviderMeasures.markMeasureStart(
			COLLAB_EDIT_PROVIDER_MEASURES.COLLAB_EDIT_PROVIDER_CONNECTED,
		);
	};

	useEffect(() => {
		if (!collabEditProvider) {
			return;
		}
		// @ts-ignore
		collabEditProvider.on('connecting', handleConnecting);
		return () => {
			// @ts-ignore
			collabEditProvider.off('connecting', handleConnecting);
		};
	}, [collabEditProvider]);
};
